module.exports = __webpack_public_path__ + "img/puppy-sales.3d38fae5.png";